import { registerComponent } from '@gig/magic-common';
import VerificationComponent from './verification.vue.js';

var Verification = registerComponent(VerificationComponent);

export { Verification };
